angular.module('unergie.main')
.controller('tagsCtrl', ($scope, $state, $uibModal, DataAccessTags, AlertManager, NgTableParams, ErrorCatcher) => {
    $scope.isActive = (state) => $state.is(state)

    $scope.search = {
        id: undefined,
    }

    $scope.tags = undefined

    const tagTemplate = {
        id: '',
        color: '#ffffff',
        bgcolor: '#000000',
    }
    $scope.tagFields = {
        id: {
            label: 'Nom',
            required: true,
            placeholder: 'Nom',
            type: 'text',
        },
        color: {
            label: 'Couleur du texte',
            placeholder: 'Couleur du texte',
            type: 'color',
        },
        bgcolor: {
            label: 'Couleur du fond',
            placeholder: 'Couleur du fond',
            type: 'color',
        },
    }

    $scope.updateTagFields = {
        color: {
            label: 'Couleur du texte',
            placeholder: 'Couleur du texte',
            type: 'color',
        },
        bgcolor: {
            label: 'Couleur du fond',
            placeholder: 'Couleur du fond',
            type: 'color',
        },
    }

    const resetTagPayload = () => ($scope.tagPayload = angular.copy(tagTemplate))

    resetTagPayload()

    const refresh = () => DataAccessTags.getTags().$promise.then((data) => ($scope.tags = data)).catch(ErrorCatcher)


    $scope.refresh = refresh
    refresh()

    $scope.addTag = function () {
        $scope.tagPayload.id = $scope.tagPayload.id.trim().replace(/ /g, '_')
        return DataAccessTags.addTag($scope.tagPayload).$promise.then(() => {
            AlertManager.success('Tag ajouté')
            resetTagPayload()
            return refresh() }).catch(ErrorCatcher)
    }

    $scope.updateTag = function (tag) {
        const tagPayload = angular.copy(tag)
        delete tagPayload.assignees
        delete tagPayload.id
        return DataAccessTags.updateTag({ id: tag.id }, tagPayload).$promise.then(() => {
            AlertManager.success('Tag modifié')
            return refresh() }).catch(ErrorCatcher)
    }

    $scope.deleteTag = (tag) =>
        DataAccessTags.deleteTag({ id: tag.id }).$promise.then(() => {
            AlertManager.success('Tag supprimé')
            return refresh() }).catch(ErrorCatcher)


    const refreshList = () =>
        DataAccessTags.allTags().$promise.then((data) => {
            $scope.tableParams = new NgTableParams(
                {
                    page: ($scope.tableParams != null ? $scope.tableParams.page() : undefined) || 1,
                    count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 25,
                    filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                    sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
                },
                {
                    dataset: data,
                },
            )
            return $scope.tableParams
        }).catch(ErrorCatcher)

    $scope.refreshList = refreshList
    return refreshList()
})
